export const loadLoginPage = () => import("@/pages/auth/LoginPage");
export const loadRegisterPage = () => import("@/pages/auth/RegisterPage");
export const loadForgotPasswordPage = () => import("@/pages/auth/ForgotPasswordPage");
export const loadInviteRegisterPage = () => import("@/pages/auth/InviteRegisterPage");
export const loadInviteRedirectPage = () => import("@/pages/auth/InviteRedirectPage");
export const loadBannedPage = () => import("@/pages/auth/BannedPage");
export const loadPendingPage = () => import("@/pages/auth/PendingPage");
export const loadRejectedPage = () => import("@/pages/auth/RejectedPage");

export const loadDashboardPage = () => import("@/pages/dashboard/DashboardPage");
export const loadRequestsPage = () => import("@/pages/requests/RequestsPage");
export const loadNewRequestPage = () => import("@/pages/requests/NewRequestPage");
export const loadRequestDetailPage = () => import("@/pages/requests/RequestDetailPage");
export const loadSitesPage = () => import("@/pages/sites/SitesPage");
export const loadSiteEditorPage = () => import("@/pages/sites/SiteEditorPage");
export const loadSiteEditsPage = () => import("@/pages/sites/SiteEditsPage");
export const loadSiteRevisionsIndexPage = () => import("@/pages/sites/SiteRevisionsIndexPage");
export const loadClientsPage = () => import("@/pages/clients/ClientsPage");
export const loadPaymentsPage = () => import("@/pages/payments/PaymentsPage");
export const loadFeedbackPage = () => import("@/pages/feedback/FeedbackPage");
export const loadFeedbackDetailPage = () => import("@/pages/feedback/FeedbackDetailPage");
export const loadSupportTicketsPage = () => import("@/features/support/SupportPages");
export const loadTicketDetailPage = () => import("@/features/support/SupportPages");
export const loadLegacySupportTicketsPage = () => import("@/pages/support/SupportTicketsPage");
export const loadLegacyTicketDetailPage = () => import("@/pages/support/TicketDetailPage");
export const loadProfilePage = () => import("@/pages/profile/NewProfilePage");
export const loadNotificationsPage = () => import("@/pages/notifications/NotificationsPage");
export const loadLeadsPage = () => import("@/pages/leads/LeadsPage");
export const loadLeadsEscalationsPage = () => import("@/pages/leads/LeadsEscalationsPage");
export const loadWenlixAnalyticsPage = () => import("@/pages/wenlix-analytics/WenlixAnalyticsPage");

export const loadAdminInvitesPage = () => import("@/pages/admin/AdminInvitesPage");
export const loadAdminPendingPage = () => import("@/pages/admin/AdminPendingPage");
export const loadAdminPremiumApprovalPage = () => import("@/pages/admin/AdminPremiumApprovalPage");
export const loadAdminPremiumProductionPage = () => import("@/pages/admin/AdminPremiumProductionPage");
export const loadAdminManagersPage = () => import("@/pages/admin/AdminManagersPage");
export const loadAdminSupervisorsPage = () => import("@/pages/admin/AdminSupervisorsPage");
export const loadAdminDirectorsPage = () => import("@/pages/admin/AdminDirectorsPage");
export const loadAdminDirectDeployPage = () => import("@/pages/admin/AdminDirectDeployPage");
export const loadAdminUsersPage = () => import("@/pages/admin/AdminUsersPage");
export const loadAdminUsersKanbanPage = () => import("@/pages/admin/AdminUsersKanbanPage");
export const loadAdminGroupsPage = () => import("@/pages/admin/AdminGroupsPageRedesign");
export const loadSiteDeletionRequestsPage = () => import("@/pages/admin/SiteDeletionRequestsPage");
export const loadAdminAppealsPage = () => import("@/pages/admin/AdminAppealsPage");
export const loadAdminAppealDetailPage = () => import("@/pages/admin/AdminAppealDetailPage");
export const loadAdminBroadcastPage = () => import("@/pages/admin/AdminBroadcastPage");
export const loadAdminBillingPage = () => import("@/pages/admin/AdminBillingPage");

const preloadedRoutes = new Set<string>();

const routePreloaders: Array<[string, () => Promise<unknown>]> = [
  ["/requests/new", loadNewRequestPage],
  ["/requests/", loadRequestDetailPage],
  ["/requests", loadRequestsPage],
  ["/sites/:id/edits", loadSiteEditsPage],
  ["/sites/:id/revisions", loadSiteEditsPage],
  ["/sites/", loadSiteEditorPage],
  ["/sites", loadSitesPage],
  ["/revisions/", loadSiteEditsPage],
  ["/revisions", loadSiteRevisionsIndexPage],
  ["/feedback/", loadFeedbackDetailPage],
  ["/feedback", loadFeedbackPage],
  ["/support/studio", loadLegacySupportTicketsPage],
  ["/support/tickets/", loadTicketDetailPage],
  ["/support/templates", loadSupportTicketsPage],
  ["/support/incidents", loadSupportTicketsPage],
  ["/support/reports", loadSupportTicketsPage],
  ["/support/sla", loadSupportTicketsPage],
  ["/support/:id/workspace", loadTicketDetailPage],
  ["/support/", loadLegacyTicketDetailPage],
  ["/support", loadSupportTicketsPage],
  ["/leads/escalations", loadLeadsEscalationsPage],
  ["/leads", loadLeadsPage],
  ["/admin/invites", loadAdminInvitesPage],
  ["/admin/pending", loadAdminPendingPage],
  ["/admin/premium-approval", loadAdminPremiumApprovalPage],
  ["/admin/premium-production", loadAdminPremiumProductionPage],
  ["/admin/managers", loadAdminManagersPage],
  ["/admin/supervisors", loadAdminSupervisorsPage],
  ["/admin/directors", loadAdminDirectorsPage],
  ["/admin/direct-deploy", loadAdminDirectDeployPage],
  ["/admin/users-kanban", loadAdminUsersKanbanPage],
  ["/admin/users", loadAdminUsersPage],
  ["/admin/groups", loadAdminGroupsPage],
  ["/admin/deletion-requests", loadSiteDeletionRequestsPage],
  ["/admin/appeals/", loadAdminAppealDetailPage],
  ["/admin/appeals", loadAdminAppealsPage],
  ["/admin/broadcast", loadAdminBroadcastPage],
  ["/admin/billing", loadAdminBillingPage],
  ["/admin", loadAdminManagersPage],
  ["/dashboard", loadDashboardPage],
  ["/clients", loadClientsPage],
  ["/payments", loadPaymentsPage],
  ["/profile", loadProfilePage],
  ["/settings", loadProfilePage],
  ["/notifications", loadNotificationsPage],
  ["/wenlix-analytics", loadWenlixAnalyticsPage],
];

function isRouteMatch(pathname: string, route: string) {
  if (route.includes(":id")) {
    const prefix = route.slice(0, route.indexOf(":id"));
    const suffix = route.slice(route.indexOf(":id") + 3);
    return pathname.startsWith(prefix) && (!suffix || pathname.endsWith(suffix));
  }
  if (route.endsWith("/")) return pathname.startsWith(route);
  return pathname === route || pathname.startsWith(`${route}/`);
}

export function preloadRoute(pathname: string) {
  const match = routePreloaders.find(([route]) => isRouteMatch(pathname, route));
  if (!match) return;

  const [route, loader] = match;
  if (preloadedRoutes.has(route)) return;
  preloadedRoutes.add(route);
  void loader();
}

export function preloadRoutes(pathnames: string[]) {
  pathnames.forEach(preloadRoute);
}
